<span [innerHTML]="getTexto()"></span>
<a class="lnk-primary" (click)="mostrarBotonVerMas = !mostrarBotonVerMas; $event.stopPropagation()" *ngIf="mostrarBotonVerMas"><u>Leer más</u></a>
